import {SVGProps} from "react";

export default function Logo(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="59"
      height="66"
      viewBox="0 0 59 66"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M53.28 65.76L44.48 58.16C40.24 60.64 35.12 62 29.28 62C11.2 62 0 48.8 0 31.04C0 13.2 11.2 0 29.28 0C47.28 0 58.48 13.2 58.48 31.04C58.48 40 55.6 47.76 50.56 53.28L58.4 60.08L53.28 65.76ZM29.28 52.88C32.08 52.88 34.56 52.4 36.72 51.44L29.36 44.96L34.4 39.2L42.8 46.56C45.68 42.64 47.12 37.28 47.12 31.04C47.12 18.64 41.04 9.12 29.28 9.12C17.44 9.12 11.28 18.64 11.28 31.04C11.28 43.36 17.44 52.88 29.28 52.88Z"
        fill="currentColor"
      />
    </svg>
  );
}
